import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '../Sidebar';
import { Header } from '../Header';
import { globalSectionLabel } from '../sections';

// Global sections own their sidebar label so the active item stays correct on
// direct URL navigation or page refresh; everything else is customer-scoped.
const getActivePage = (pathname: string): string =>
  globalSectionLabel(pathname) ?? 'Customers'

export const MainLayout: React.FC = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobileOrTablet);
  const [activePage, setActivePage] = useState(() => getActivePage(location.pathname));

  // Keep activePage in sync when the route changes (e.g. browser back/forward)
  useEffect(() => {
    setActivePage(getActivePage(location.pathname))
  }, [location.pathname]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
<Box display="flex">
  <Sidebar
    open={isSidebarOpen}
    setOpen={setIsSidebarOpen}
    onSelect={setActivePage}
    activePage={activePage}
    onToggleSidebar={toggleSidebar}
  />
  <Box flex={1} display="flex" flexDirection="column" overflow="hidden">
    <Header title={activePage} />
    <Box flex={1} p={3}>
      <Outlet />
    </Box>
  </Box>
</Box>
  );
};
